export default {
    getTabHeaders: (state) => (page) => {
        return state.tabHeaders[page];
    },
    getTabView: (state) => {
        return state.tabView;
    },
};
